import VueRecaptcha from 'vue-recaptcha'
import { CONFIG } from '@/config'
// import { FBFUNCTIONS } from '@/plugins/firebase'
export default {
  components: {
    'vue-recaptcha': VueRecaptcha,
  },

  data: () => ({
    sitekey: CONFIG.reCaptcha.sitekey,
    isHuman: false,
  }),

  methods: {
    onVerify (payload) {
      // console.log('Verify: ' + payload)
      this.isHuman = payload
      /* const saveForm = FBFUNCTIONS.httpsCallable('reCaptchaValidate')
      saveForm(payload)
        .then(response => {
          console.info('Validado')
          this.isHuman = response.data.isHuman
        })
        .catch(error => {
          console.error(error)
        }) */
    },

    onExpired () {
      // console.log('Expired')
      this.resetRecaptcha()
    },

    resetRecaptcha () {
      // console.log('reseteando...')
      this.$refs.recaptcha.reset() // Direct call reset method
      this.isHuman = false
    },
  },
}
